import React, { useState } from "react";
import { Formik } from "formik";
import { Button, Grid, FormControl, InputLabel, OutlinedInput, MenuItem, Select, CircularProgress, Modal, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    title: {
        fontSize: "20px",
        textAlign: "center",
        color: theme.palette.primary.main,
        marginBottom: "7%"
    },
    buttonProgress: {
        marginLeft: '50%'
    }
}));

export const AñadirOximetriaModal = ({ open, handleClose, dataEdit, createOximetria, numeroDocumento, Basculas }) => {
    const classes = useStyles();
    const [isLoanding, setisLoanding] = useState(false);

    return (
        <Modal open={open} onClose={handleClose}>
            <div className={classes.paper}>
                <Typography className={classes.title}> Registrar medición de Oximetria</Typography>
                <Formik
                    initialValues={{
                        Oximetria: "",
                        Evbi: ""
                    }}

                    validate={(valores) => {
                        let errores = {};

                        if (!valores.Oximetria) {
                            errores.Oximetria = 'Por favor ingresa un valor numérico para la oximetría';
                        }

                        return errores;
                    }}

                    onSubmit={(valores, { resetForm }) => {
                        setisLoanding(true);

                        const data = {
                            oximetria: valores.Oximetria,
                            evbi: valores.Evbi,
                            numeroDocumento: numeroDocumento
                        };

                        createOximetria(data);
                        valores.isLoading = true;
                        setTimeout(() => {
                            setisLoanding(false);
                            handleClose();
                        }, 500);

                        resetForm();
                    }}
                >
                    {({ values, errors, touched, handleSubmit, handleChange, handleBlur }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={3} style={{ textAlign: "left" }}>
                                <Grid item xs={12} md={12} sm={12}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel htmlFor="Oximetria">Oximetría</InputLabel>
                                        <OutlinedInput
                                            id="Oximetria"
                                            type="number"
                                            name="Oximetria"
                                            value={values.Oximetria}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            labelWidth={100}
                                            style={{ borderRadius: '10px' }}
                                        />
                                    </FormControl>
                                    {touched.Oximetria && errors.Oximetria && <div style={{ color: "red" }}>{errors.Oximetria}</div>}
                                </Grid>
                                <Grid item xs={12} md={12} sm={12}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel htmlFor="Evbi">Evbi</InputLabel>
                                        <Select
                                            id="Evbi"
                                            name="Evbi"
                                            value={values.Evbi}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            labelWidth={70}
                                            style={{ borderRadius: '10px' }}
                                        >
                                            {Basculas.map((bascula) => (
                                                <MenuItem key={bascula.id} value={bascula.id}>{bascula.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <div className={classes.wrapper}>
                                <Grid container justifyContent="center" style={{ marginTop: '10px' }}>
                                    <Button
                                        disabled={isLoanding}
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        style={{ textTransform: "none", width: "50%", borderRadius: '10px' }}
                                    >
                                        Registrar
                                    </Button>
                                </Grid>
                                {isLoanding && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </Modal>
    );
};
